module.exports = __webpack_public_path__ + "static/media/plantB.58e08eb0.png";